export const AccountHeadersModel = [
    {
        text: "Действия",
        value: "actions",
        sortable: false
    },
    {
        text: "Имя программы",
        value: "campaign.name"
    },
    {
        text: "Счёт по дебиту (Счёт списания бонусов)",
        value: "accountAccrual.amount"
    },
    {
        text: "Счёт по кредиту (Счёт начисления бонусов)",
        value: "accountEmission.amount"
    },

]
